import { GetItemLedgerReportRecords, GetItemWisePendingReport, GetPartyWisePendingReport, GetReportPendingItems, GetReportPendingParties } from "../ApiEndPoints_1";
import { axiosPostAuthorize } from "../AxiosRequests";

export default class TransactionReoprtServices {

    async getItemLedgerReportRecords(request) {
        return axiosPostAuthorize(GetItemLedgerReportRecords, request);
    }

    async getItemWisePendingReport(request) {
        return axiosPostAuthorize(GetItemWisePendingReport, request);
    }

    async getPartyWisePendingReport(request) {
        return axiosPostAuthorize(GetPartyWisePendingReport, request);
    }

    async getReportPendingItems(request) {
        return axiosPostAuthorize(GetReportPendingItems, request);
    }

    async getReportPendingParties(request) {
        return axiosPostAuthorize(GetReportPendingParties, request);
    }

}
